import { render, staticRenderFns } from "./OrderPlanSuccess.vue?vue&type=template&id=1515593e&scoped=true&"
import script from "./OrderPlanSuccess.vue?vue&type=script&lang=js&"
export * from "./OrderPlanSuccess.vue?vue&type=script&lang=js&"
import style0 from "./OrderPlanSuccess.vue?vue&type=style&index=0&id=1515593e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1515593e",
  null
  
)

/* custom blocks */
import block0 from "./OrderPlanSuccess.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./OrderPlanSuccess.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
